import { render, staticRenderFns } from "./UterusForm.vue?vue&type=template&id=18b789bd&"
import script from "./UterusForm.vue?vue&type=script&lang=js&"
export * from "./UterusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports